import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogComposerFormatToolbarButton from './VeltCommentDialogComposerFormatToolbarButton/VeltCommentDialogComposerFormatToolbarButton';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentDialogComposerFormatToolbar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-format-toolbar-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerFormatToolbar.Button = VeltCommentDialogComposerFormatToolbarButton;
export default VeltCommentDialogComposerFormatToolbar;
